// extracted by mini-css-extract-plugin
export default {"noTime":"noTime-kp6Lu","estimatedTime":"estimatedTime-PbBSl"};